define.alias("shared/components/shared/social/connect-profile", "calendar/components/shared/social/connect-profile");